import React from 'react';
import PropTypes from 'prop-types';

import { setNamespace } from '@utils/namespacing';

// import Assets
import { ReactComponent as PremiumContent } from '@assets/images/premium-content.svg';

// import components
import Subheading from '../Typography/Subheading';
import Button from '../Buttons/Button';

import './_subscriptionBreach.scss';

const namespacify = setNamespace('et-core-subBreach');

const SubscriptionBreach = ({ topText, bottomText, handleLogin, handleSubscribe }) => {
  return (
    <div className={namespacify('')}>
      <PremiumContent className={namespacify('_logo')}/>
      {topText && <Subheading customClasses={{ root: namespacify('_topText') }}>{topText}</Subheading>}
      <div className={namespacify('_bottomText')}>
        {bottomText && bottomText.split('\n').map((text, i) => <div key={i}>{text}</div>)}
      </div>
      <div className={namespacify('_buttonWrap')}>
        <Button stretch handleClick={handleSubscribe} className={namespacify('_loginBtn')}>Register</Button>
        <Button stretch handleClick={handleLogin} className={namespacify('_loginBtn')}>Login</Button>
      </div>
    </div>
  );
};

SubscriptionBreach.propTypes = {
  handleLogin: PropTypes.func.isRequired,
  handleSubscribe: PropTypes.func.isRequired,
};

SubscriptionBreach.defaultProps = {
  handleLogin: () => console.log('SubscriptionBreach default handleLogin'),
  handleSubscribe: () => console.log('SubscriptionBreach default handleSubscribe'),
  topText: 'Premium Content',
  bottomText: 'Register or log in to use this feature'
};

export default SubscriptionBreach;
